<template>
    <div class="table-responsive mb-4">
        <table class="table table-bordered">
            <thead>
            <tr>
                <th>Product</th>
                <th class="text-end">P. Rate</th>
                <th class="text-end">Qty</th>
                <th class="text-end">Amount</th>
                <th class="text-center">Action</th>
            </tr>
            </thead>

            <tbody v-if="isArray(itemDetails) && itemDetails.length">
            <tr v-for="(item, index) in itemDetails" :key="index">
                <td>{{ item.product_name }}</td>
                <td class="text-end">{{ item.rate }}</td>
                <td class="text-end">{{ item.quantity }}</td>
                <td class="text-end">{{ item.rate * item.quantity }}</td>
                <td class="text-center">
                    <button
                        class="btn btn-sm btn-primary me-1"
                        @click="editItem(item, index)"
                    >
                        <i class="fa fa-pencil-alt"></i>
                    </button>

                    <button
                        class="btn btn-sm btn-danger"
                        @click="$emit('removeBill', index)"
                    >
                        <i class="fa fa-trash"></i>
                    </button>
                </td>
            </tr>
            </tbody>

            <tbody v-else>
            <tr>
                <td colspan="5" class="text-center text-muted">
                    No items added
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script setup>
import {isArray} from "lodash";

const props = defineProps({
    itemDetails: {
        type: Array,
        default: () => []
    },
    formRef: {
        type: Object,
        required: true
    }
});

const editItem = (item, index) => {
    item.isEdit = true;
    props.formRef.setData(item);
    props.formRef.updateIndex = index;
};
</script>
